// extracted by mini-css-extract-plugin
module.exports = {"author":"styles_author__a2_uT","avatar":"styles_avatar__dA1c5","authorInfo":"styles_authorInfo___carz"};